export enum OrderStatus {
  PASSED = 'Passed',
  ISSUES_FOUND = 'Issues Found',
  WARNING = 'Warning',
  LIMIT_REACHED = 'Limit Reached',
  EXPIRED = 'Expired',
  PENDING = 'Pending',
  FAILED = 'Failed',
  USER_CANCELLED = 'User Cancelled',
  REQUEST_CANCELLED = 'Request Cancelled',
}

export interface OrderSummaryBase {
  lastOrderId: string;
  lastStatus: OrderStatus;
  lastStatusDate: string;
}

export interface IdentityVerificationSummary extends OrderSummaryBase {
  attemptRemaining: number;
}

export type ContactValidationSummary = OrderSummaryBase;

export interface PartyVerificationListResult {
  fileId: string;
  fileNumber: string;
  underwriterCode: string;
  underwriterName: string;
  partyName: string;
  requestedByName: string;
  requestedBy: string;
  requestedDate: string;
  identityVerificationOrdersSummary?: IdentityVerificationSummary;
  contactValidationOrdersSummary?: ContactValidationSummary;
}
export interface PartyRow {
  fileId: string;
  fileNumber: string;
  underwriter: string;
  partyName: string;
  requestedByName: string;

  cvStatus?: OrderStatus;
  cvDate?: string;

  idvStatus?: OrderStatus;
  idvDate?: string;
  idvAttemptsLeft?: number;
  idvOrderId?: string;

  lastRun?: string;
}
